<template>
  <div
    ref="container"
    class="breadcrumb-bar d-flex flex-row align-center w-100 bg-white relative py-3 px-8"
  >
    <!-- User Folders -->
    <template v-if="!$vuetify.display.xs">
      <template v-for="(item, index) in visibleFolders" :key="index">
        <div class="d-flex flex-row align-center breadcrumb-item" @click="item.onClick">
          <app-material-icon v-if="item.type === 'root'" name="rectangle-history" type="fa" size="xs" />
          <app-material-icon v-else-if="item.type === 'folder'" name="folder" type="fa" size="xs" />

          <span v-if= "!$vuetify.display.xs" class="breadcrumb-item-label text-grey-700 clickable text-truncate ml-2">
          {{ item.title }}
        </span>
        </div>

        <div>
          <span class="d-flex mx-1">
            <app-material-icon name="chevron-right" type="fa" size="xxs" class="px-1" />
          </span>
        </div>
      </template>
    </template>

    <template v-if="shouldShowEllipsis && !$vuetify.display.xs">
      <v-menu
        class="rounded-lg"
        location="bottom start"
        offset="5"
      >
        <template #activator="{ props }">
          <app-button
            class="ellipsis-button"
            type="ghost"
            v-bind="props"
          >
            ...
          </app-button>
        </template>

        <v-list class="ellipsis-popover">
          <v-list-item
            v-for="(item, index) in hiddenFolders"
            :key="index"
            @click="item.onClick"
          >
            <template #prepend>
              <app-material-icon name="folder" type="fa" size="xs" />
            </template>
            <v-list-item-title>
              <span class="text-grey-900 ml-2">
                {{ item.title }}
              </span>
            </v-list-item-title>
          </v-list-item>
        </v-list>

      </v-menu>

      <div>
        <span class="d-flex mx-1">
          <app-material-icon name="chevron-right" type="fa" size="xxs" class="px-1" />
        </span>
      </div>
    </template>

    <template v-if="$vuetify.display.xs">
      <app-material-icon name="rectangle-history" type="fa" size="xs" />

      <div>
        <span class="d-flex mx-1">
          <app-material-icon name="chevron-right" type="fa" size="xxs" class="px-1" />
        </span>
      </div>

      <template v-if="room.userFoldersPath.length > 0">
        <app-button
          class="ellipsis-button"
          type="ghost"
          v-bind="props"
          @click="isMobileDialogOpen = true"
        >
          ...
        </app-button>

        <div>
          <span class="d-flex mx-1">
            <app-material-icon name="chevron-right" type="fa" size="xxs" class="px-1" />
          </span>
        </div>
      </template>
    </template>

    <AppBarRoomBreadcrumbMobileDialog
      v-if="isMobileDialogOpen"
      :folders="breadcrumbItems"
      :room="room"
      :navigationPage="currentNavigationPage"
      @close="isMobileDialogOpen = false"
    />

    <!-- Room -->
    <div class="d-flex flex-row align-center shrinkable breadcrumb-item">
      <RoomTypeIcon
        :room="{ isDataroom: room.isDataroom }"
        :width="19"
      />
      <AppTooltip
        v-if="!$vuetify.display.xs"
        :max-width="TOOLTIP_MAX_WIDTH"
        location="bottom"
      >
        <template #activator="{ props }">
          <span
            class="breadcrumb-item-label text-grey-700 clickable text-truncate ml-2"
            v-bind="props"
            @click="onCurrentRoomClick"
          >
            {{ room.name }}
          </span>
        </template>
        {{ room.name }}
      </AppTooltip>
    </div>

    <div>
        <span class="d-flex mx-1">
          <app-material-icon name="chevron-right" type="fa" size="xxs" class="px-1" />
        </span>
    </div>

    <!-- Current page -->
    <div class="d-flex flex-row align-center text-no-wrap">
      <app-material-icon
        :name="currentNavigationPage.icon"
        size="xs"
      />

      <span class="breadcrumb-item-label text-grey-800 font-weight-medium ml-2">
        {{ $t(`${NAVIGATION_TRANSLATION_KEY_PREFIX}.${currentNavigationPage.translationKey}`) }}
      </span>
    </div>
  </div>
  <!-- Hidden measurement row -->
  <div
    ref="measureRow"
    style="position: absolute; left: -9999px; top: -9999px; visibility: hidden; white-space: nowrap;"
    class="d-flex flex-row align-center w-100"
  >
    <template v-for="(item, index) in breadcrumbItems" :key="index">
      <div
        :ref="el => setMeasureFolderRef((el as HTMLElement))"
        class="d-flex flex-row align-center breadcrumb-item"
      >
        <app-material-icon v-if="item.type === 'root'" name="rectangle-history" type="fa" size="xs" />
        <app-material-icon v-else-if="item.type === 'folder'" name="folder" type="fa" size="xs" />

        <span class="breadcrumb-item-label text-grey-700 clickable text-truncate">
          {{ item.title }}
        </span>
      </div>

      <div v-if="index < breadcrumbItems.length - 1">
          <span class="d-flex mx-1">
            <app-material-icon name="chevron-right" type="fa" size="xxs" class="px-1" />
          </span>
      </div>
    </template>

    <!-- Room -->
    <div ref="measureRoomElement" class="d-flex flex-row align-center">
      <RoomTypeIcon
        class="mr-2"
        :room="{ isDataroom: room.isDataroom }"
        :width="19"
      />

      <span class="breadcrumb-item-label text-grey-700 clickable text-truncate">
          {{ room.name }}
        </span>
    </div>

    <div>
      <span class="d-flex mx-1">
        <app-material-icon name="chevron-right" type="fa" size="xxs" class="px-1" />
      </span>
    </div>

    <!-- Current page -->
    <div ref="measureCurrentPageElement" class="d-flex flex-row align-center text-no-wrap">
      <app-material-icon
        :name="currentNavigationPage.icon"
        size="xs"
      />

      <span class="breadcrumb-item-label text-grey-800 font-weight-medium ml-2">
        {{ $t(`${NAVIGATION_TRANSLATION_KEY_PREFIX}.${currentNavigationPage.translationKey}`) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { debounce } from "lodash-es"
import { computed, ComputedRef, nextTick, onBeforeUnmount, onMounted, ref } from "vue"
import { useRouter } from "vue-router"
import { useStore } from "vuex";

import AppBarRoomBreadcrumbMobileDialog from "@/common/app-bar/AppBarRoomBreadcrumbMobileDialog.vue"
import RoomTypeIcon from "@/common/RoomTypeIcon.vue"
import { APP_HEADER_HEIGHT } from "@/common/constants"
import { calculateVisibleFolders} from "@/common/utils/breadcrumbUtils"
import { getRoomDefaultRoute } from "@/common/utils/rooms";
import { useTranslation } from "@/common/utils/translation"
import { FOLDER_CHILD_ROUTE_NAME, FOLDER_ROUTE_NAME, ROOMS_ROUTE_NAME } from '@/router/routerData'

import AppTooltip from "../AppTooltip.vue"


const TOOLTIP_MAX_WIDTH = 600

export type Room = {
  id: number
  name: string
  mnemo: string
  isDataroom: number
  userFoldersPath: Array<UserFolder>
};

type UserFolder = {
  id: number
  name: string
}

export type Crumb = {
  type: 'root' | 'folder'
  title: string
  onClick?: () => void
}

export type NavigationDataPage = {
  translationKey: string
  icon: string
  locatorValue: string
}

const NAVIGATION_TRANSLATION_KEY_PREFIX = 'project.ProjectSidebar'

const { t } = useTranslation({ keyPrefix: 'common.app-bar.AppBarRoomBreadcrumb' })
const router = useRouter()
const store = useStore()

const props = defineProps<{
  room: Room
  currentNavigationPage: NavigationDataPage
}>();

const currentRoom = store.state.room.currentRoom

const onCurrentRoomClick = () => {
  router.push(getRoomDefaultRoute(currentRoom))
}

const breadcrumbItems: ComputedRef<Crumb[]> = computed(() => {
  let items: Crumb[] = [{
    type: 'root',
    title: t('projects'),
    onClick: () => {
      router.push({ name: ROOMS_ROUTE_NAME })
    },
  }]

  let previousFolderCrumb: number | null = null

  props.room.userFoldersPath.forEach((folder) => {
    const currentPrevious = previousFolderCrumb

    items.push({
      type: 'folder',
      title: folder.name,
      onClick: () => {
        if (currentPrevious !== null) {
          router.push({ name: FOLDER_CHILD_ROUTE_NAME, params: {
            folderId: currentPrevious,
            childId: folder.id,
          }})
        } else {
          router.push({ name: FOLDER_ROUTE_NAME, params: {
            folderId: folder.id,
          }})
        }
      },
    })

    previousFolderCrumb = folder.id
  })

  return items
})

const APP_HEADER_HEIGHT_STYLE = APP_HEADER_HEIGHT + 'px'

const container = ref<HTMLElement | null>(null)
const measureRow = ref<HTMLElement | null>(null)
const measureFolderRefs = ref<HTMLElement[]>([])
const measureRoomElement = ref<HTMLElement | null>(null)
const measureCurrentPageElement = ref<HTMLElement | null>(null)
const visibleFolders = ref<Array<Crumb>>([])
const hiddenFolders = ref<Array<Crumb>>([])
const shouldShowEllipsis = ref(false)
const isMobileDialogOpen = ref(false)

function setMeasureFolderRef(el: HTMLElement | null) {
  measureFolderRefs.value.push(el as HTMLElement)
}

const CALCULATE_VISIBLE_FOLDERS_DEBOUNCE_MS = 50
const SEPARATOR_WIDTH = 28

function refreshVisibleFolders() {
  nextTick(() => {
    const fixedElementsSize =
      (measureRoomElement.value?.offsetWidth ?? 0)
      + (measureCurrentPageElement.value?.offsetWidth ?? 0)
      + 2 * SEPARATOR_WIDTH
      + 20 // safe zone for existing ellipsis
    let visibleFoldersNb = calculateVisibleFolders(container, measureRow, measureFolderRefs, breadcrumbItems.value, SEPARATOR_WIDTH, fixedElementsSize)

    if (visibleFoldersNb === null) {
      visibleFolders.value = []
      shouldShowEllipsis.value = false
      return
    }

    visibleFoldersNb = Math.max(1, visibleFoldersNb)

    shouldShowEllipsis.value = visibleFoldersNb < breadcrumbItems.value.length
    visibleFolders.value = breadcrumbItems.value.slice(0, visibleFoldersNb)
    hiddenFolders.value = breadcrumbItems.value.slice(visibleFoldersNb)

    return;
  })
}
const debouncedRefreshVisibleFolders =
  debounce(refreshVisibleFolders, CALCULATE_VISIBLE_FOLDERS_DEBOUNCE_MS)

let resizeObserver: ResizeObserver

onMounted(() => {
  if (container.value) {
    resizeObserver = new ResizeObserver(() => {
      debouncedRefreshVisibleFolders()
    })
    resizeObserver.observe(container.value)
  }
  debouncedRefreshVisibleFolders()
})
onBeforeUnmount(() => {
  if (resizeObserver && container.value) {
    resizeObserver.unobserve(container.value)
    resizeObserver.disconnect()
  }
  debouncedRefreshVisibleFolders.cancel?.()
})
</script>

<style scoped lang="scss">
.breadcrumb-bar {
  height: 52px;
  border-bottom: 1px solid rgb(var(--v-theme-grey-100));
  border-top: 1px solid rgb(var(--v-theme-grey-100));
  position: sticky;
  top: v-bind(APP_HEADER_HEIGHT_STYLE);
  z-index: 1;
}

.breadcrumb-item:hover > .clickable {
  text-decoration: underline;
}

.ellipsis-button {
  min-height: auto !important;
  padding: 0 5px !important;
}

.ellipsis-popover {
  box-shadow: none !important;
  border: 1px solid rgb(var(--v-theme-grey-200));
}
</style>
